import { connect } from 'react-redux';
import pick from 'lodash/pick';
import { fetchListings } from 'listing/listing.actions';
import Listings from 'pages/Listings';

function mapStateToProps(state) {
  const listings = pick(state.listings.results, state.listings.searchResults);
  return {
    pageTitle: state.website.title,
    resultCount: state.listings.count,
    listings,
    listingCount: Object.keys(listings).length,
    isFetching: state.listings.isFetching,
    isFetchingMore: state.listings.isFetchingMore,
    skip: state.listings.skip,
    cities: state.cities,
    maxGuests: state.website.maxGuests,
    query: state.listings.query,
    markers: Object.keys(listings).map(l => ({ listing: listings[l], position: { lng: listings[l].address.lng, lat: listings[l].address.lat }}))
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchListings: options => dispatch(fetchListings(options))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Listings);


// WEBPACK FOOTER //
// ./src/containers/Listings.container.js